export type AdminMessage = {
  title?: string // only required if blocking is true
  message: string
  blocking: boolean
}

export type AdminMessageExtensionType = 'admin_message'

export const ADMIN_MESSAGE_EXTENSION_TYPE: AdminMessageExtensionType = 'admin_message'
